import { useTour } from "../../core/hooks/useTour.js";
import { useCoreQuery } from "../../core/hooks/use-core-query.js";
import { getMenuSteps } from "../../core/utils/tour.js";
import { useMenuAxios } from "../../core/context/axios.js";
import { setSeen } from "../../core/data/mutation.js";
import { useCallback, useEffect, useRef } from "react";
import { useMutation } from "@tanstack/react-query";
//#region src/modules/menubar/hooks/useMenuTour.tsx
/**
*
* @param {boolean} menuOnboardingSeen
* @returns {React.MutableRefObject} React reference to parent anchor element
*/
var useMenuTour = (menuOnboardingSeen) => {
	const { instance } = useMenuAxios();
	const { setIsOpen, setSteps } = useTour();
	const ref = useRef(null);
	const { mutateAsync } = useMutation({ mutationFn: (id) => setSeen(instance, id) });
	const { refetch } = useCoreQuery();
	const setOnboarding = useCallback(async () => {
		try {
			await mutateAsync("MENU");
			await refetch();
		} catch (error) {
			console.error(error);
		}
	}, [mutateAsync, refetch]);
	useEffect(() => {
		if (ref.current && !menuOnboardingSeen) {
			setSteps?.(getMenuSteps(ref, setOnboarding));
			setTimeout(() => setIsOpen(true), 1e3);
		}
	}, [
		ref,
		setSteps,
		menuOnboardingSeen,
		setIsOpen,
		mutateAsync,
		setOnboarding
	]);
	return ref;
};
//#endregion
export { useMenuTour };
